import { i18n } from "@/i18n";

export default function getDiscProfileDescriptions( { assessment, person, } ) {
	const items = [];
	items.push( {
		description: i18n.t( "profile.DiscProfile_behaviorSectionHeader", { person, } ),
		icon: "fa-user-check",
		items: assessment.content.behavior.phrase,
	} );
	items.push( {
		description: i18n.t( "profile.DiscProfile_motivationsSectionHeader", { person, } ),
		icon: "fa-user-plus",
		items: assessment.content.motivation.phrase,
	} );
	items.push( {
		description: i18n.t( "profile.DiscProfile_drainsSectionHeader", { person, } ),
		icon: "fa-user-minus",
		items: assessment.content.drainer.quality || assessment.content.drainer.phrase,
	} );
	return items;
}



// WEBPACK FOOTER //
// ./src/helpers/getDiscProfileDescriptions.js